export default __webpack_public_path__ + "static/media/graf.aba8cc4f.mp4";